export enum BusinessType {
  B2B = 'b2b',
  B2C = 'b2c',
  Mixed = 'mixed',
}
